import {GetServiceCaseOrderVariantsApiResponse} from '@dms/api/workshop';

export const getOptionsFromServiceCaseOrderVariants = (
  serviceCaseOrderVariants: GetServiceCaseOrderVariantsApiResponse
) =>
  serviceCaseOrderVariants?.map((variant) => ({
    label: variant?.name ?? '',
    value: variant?.id ?? '',
  })) ?? [];
